<template>
  <div class="tag">
    <i v-if="removable" class="del" @click.prevent="$emit('remove')"></i>
    <span class="content"><slot></slot></span>
  </div>
</template>

<script>
  export default {
    name: 'ihu-tag',
    props: {
      removable: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped lang="scss">
  .tag {
    width: auto;
    padding: 0 5px;
    margin: 2px;

    @include themify {
      border: getColor('ihuTagBorder', 'ihu');
      background: getColor('ihuTagBackground', 'ihu');
    }

    box-sizing: border-box;
    border-radius: 32px;

    .del {
      cursor: pointer;
      width: 8px;
      height: 8px;
      display: inline-block;

      @include themify('dark') {
        background: url('~@/components/common/assets/navigation/close_cross_dark.svg') no-repeat center;
      }
      @include themify('light') {
        background: url('~@/components/common/assets/navigation/close_cross_light.png') no-repeat center;
      }
    }
    .content {
      margin: 0 4px;
    }
  }
</style>
